import { render, staticRenderFns } from "./bookmarkButton.vue?vue&type=template&id=9054e20e&lang=html&"
import script from "./bookmarkButton.vue?vue&type=script&lang=js&"
export * from "./bookmarkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports